module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-toolbar"
  }, [_c('div', {
    staticClass: "dt-tabs",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.visibleTabs), function(t) {
    return _c('button', {
      key: t.key,
      staticClass: "dt-tab",
      class: {
        active: _vm.tab === t.key
      },
      attrs: {
        "type": "button",
        "role": "tab",
        "aria-selected": _vm.tab === t.key ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.$emit('tabChange', t.key)
        }
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dt-right"
  }, [(_vm.viewMode === 'grid') ? _c('label', {
    staticClass: "dt-sort"
  }, [_c('span', {
    staticClass: "dt-sort-label"
  }, [_vm._v("Sort:")]), _vm._v(" "), _c('select', {
    staticClass: "md-select md-theme-default",
    domProps: {
      "value": _vm.sortValue
    },
    on: {
      "change": function($event) {
        return _vm.onSortSelect($event.target.value)
      }
    }
  }, [_c('option', {
    staticClass: "md-option",
    attrs: {
      "value": "date-desc"
    }
  }, [_vm._v("Date (newest to oldest)")]), _vm._v(" "), _c('option', {
    staticClass: "md-option",
    attrs: {
      "value": "date-asc"
    }
  }, [_vm._v("Date (oldest to newest)")]), _vm._v(" "), _c('option', {
    staticClass: "md-option",
    attrs: {
      "value": "name-asc"
    }
  }, [_vm._v("Name (A to Z)")]), _vm._v(" "), _c('option', {
    staticClass: "md-option",
    attrs: {
      "value": "name-desc"
    }
  }, [_vm._v("Name (Z to A)")])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dt-view"
  }, [_c('span', {
    staticClass: "dt-view-label"
  }, [_vm._v("View:")]), _vm._v(" "), _c('button', {
    staticClass: "dt-view-btn",
    class: {
      active: _vm.viewMode === 'list'
    },
    attrs: {
      "type": "button",
      "aria-pressed": _vm.viewMode === 'list' ? 'true' : 'false',
      "aria-label": "List view"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('viewChange', 'list')
      }
    }
  }, [_c('md-icon', [_vm._v("view_list")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("List view")])], 1), _vm._v(" "), _c('button', {
    staticClass: "dt-view-btn",
    class: {
      active: _vm.viewMode === 'grid'
    },
    attrs: {
      "type": "button",
      "aria-pressed": _vm.viewMode === 'grid' ? 'true' : 'false',
      "aria-label": "Thumbnail view"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('viewChange', 'grid')
      }
    }
  }, [_c('md-icon', [_vm._v("view_module")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("Thumbnail view")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90a8088c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashboard-toolbar.vue
// module id = 1278
// module chunks = 21